import InfoBlock from "../../../../src/components/custom-blocks/info-block";
import CssFocus from "../../../../src/posts/2019-10-25-react-ref-autofocus/css-focus.mdx";
import * as React from 'react';
export default {
  InfoBlock,
  CssFocus,
  React
};